(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./PhraseScore.module.css";

const findHighestScorePhrase = phrases => {
  let result = {
    score: 0
  };
  phrases.forEach(phrase => {
    if (phrase.score > result.score) {
      result = phrase;
    }
  });
  return result;
};

const makeWordColorMap = phrases => {
  const highestScorePhrase = findHighestScorePhrase(phrases);
  return phrases === null || phrases === void 0 ? void 0 : phrases.map(_ref => {
    let {
      phrase,
      score
    } = _ref;
    const minOpacity = 0.2;
    const obj = {
      phrase,
      color: "rgb(51, 55, 65, ".concat(minOpacity, ")")
    };
    let opacity;

    if (score) {
      if (score === highestScorePhrase.score && score < 0.5) {
        opacity = 0.5;
      } else {
        opacity = minOpacity > score ? minOpacity : score;
      }

      obj.color = "rgb(51, 55, 65, ".concat(opacity, ")");
    }

    return obj;
  });
};

const PhraseScore = _ref2 => {
  let {
    phraseImportances
  } = _ref2;
  const wordColorMap = useMemo(() => makeWordColorMap(phraseImportances), [phraseImportances]);
  return /*#__PURE__*/React.createElement("span", {
    className: styles.phraseScore
  }, wordColorMap.map((w, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line
  React.createElement("span", {
    style: {
      color: w.color
    },
    key: "".concat(index, "-").concat(w.phrase)
  }, w.phrase, "\xA0")));
};

__signature__(PhraseScore, "useMemo{wordColorMap}");

PhraseScore.propTypes = {
  phraseImportances: PropTypes.arrayOf(PropTypes.shape({
    score: PropTypes.number.isRequired,
    phrase: PropTypes.string.isRequired
  })).isRequired
};

const _default = /*#__PURE__*/React.memo(PhraseScore);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(findHighestScorePhrase, "findHighestScorePhrase", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/PhraseScore/PhraseScore.jsx");
  reactHotLoader.register(makeWordColorMap, "makeWordColorMap", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/PhraseScore/PhraseScore.jsx");
  reactHotLoader.register(PhraseScore, "PhraseScore", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/PhraseScore/PhraseScore.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/PhraseScore/PhraseScore.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();